import propType from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import { Card } from '../Card';
import { SlickArrowLeft, SlickArrowRight } from './components/SlickArrow';

const Recommendation = ({ title, articles }) => {
  const posts = articles.map((article) => (
    <Card
      key={article?.title}
      type="vertical"
      imageSrc={article?.featuredImage}
      uri={article?.uri}
      className="recommendation__article"
    >
      <Card.Content key="content">
        <Card.Title>{article?.title}</Card.Title>
      </Card.Content>
    </Card>
  ));

  const settings = {
    dots: true,
    slidesToShow: Math.min(3, articles.length),
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  };

  return (
    <section className="recommendation__wrapper">
      <h2 className="recommendation__title">{title}</h2>
      <article className="recommendation__article__wrapper">
        <Slider {...settings}>{posts}</Slider>
      </article>
    </section>
  );
};

Recommendation.propTypes = {
  title: propType.string.isRequired,
  articles: propType.arrayOf(propType.shape({})).isRequired
};

export default Recommendation;
